import { FaExternalLinkAlt } from "react-icons/fa";
import { imageUrlFor } from "../../../lib/image-url";
import BlockText from "../../block-content/block-text";
import Image from "gatsby-plugin-sanity-image";

const ContentBlock = ({ image, link, title, videoID, _rawBody }) => {
  const hasLink = link?.href || link?.reference?.path;

  return (
    <div
      className={`content-block${hasLink ? " cursor-pointer" : ""}`}
      onClick={(evt) => {
        if (hasLink) {
          evt.preventDefault();
          window.location.href = link.href || link.reference.path;
        }
      }}
    >
      {!videoID && image && image.asset && (
        <Image
          className="content-block__image"
          {...image}
          width={323}
          height={353}
        />
      )}
      {videoID && (
        <iframe
          className="content-block__video"
          src={`https://www.youtube.com/embed/${videoID.trim()}`}
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        ></iframe>
      )}
      <div className="content-block__copy p-2 pb-0 font-bold tracking-tight text-gray-900">
        {title && (
          <h2 className="content-block__title leading-none tracking-tighter text-2xl mb-1 text-blue-500 mb-2">
            {title}
          </h2>
        )}
        {_rawBody && (
          <div className="content-block__description">
            <BlockText
              isPlain={true}
              className="content-block__description"
              blocks={_rawBody}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ContentBlock;
